module.exports = __webpack_public_path__ + "static/img/RSGUPS108R_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RSGUPS108R_1.png
// module id = dIds
// module chunks = 0